import { useState } from "react";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import { useCartContext } from "../../context/CartContext";
import { BASE_URL } from '../../constants';
import LoginModal from "../LoginModal";
import './ProductDetail.css'
import SpacialOffer from "./SpacialOffer";
import RelatedProduct from "./RelatedProduct";
const logo = "/assets/images/menu/logo/redCarat-01.png";
// Gallery, colors, sizes, deals, accordion
const galleryImages = [
  { src: "https://placehold.co/480x480/F5F0EA/C9A84C?text=✦+View+1", thumb: "https://placehold.co/60x60/F5F0EA/C9A84C?text=1", alt: "Front view" },
  { src: "https://placehold.co/480x480/EDE8E0/9A7B2E?text=✦+View+2", thumb: "https://placehold.co/60x60/EDE8E0/9A7B2E?text=2", alt: "Side view" },
  { src: "https://placehold.co/480x480/F0ECE4/C9A84C?text=✦+View+3", thumb: "https://placehold.co/60x60/F0ECE4/C9A84C?text=3", alt: "Detail view" },
  { src: "https://placehold.co/480x480/E8E4DC/9A7B2E?text=✦+View+4", thumb: "https://placehold.co/60x60/E8E4DC/9A7B2E?text=4", alt: "Worn view" },
];

const colors = [
  { id: "gold", label: "Gold", hex: "#C9A84C" },
  { id: "rose", label: "Rose Gold", hex: "#E8B4B8" },
];

const sizes = ["XS", "S", "M", "L", "XL"];

const deals = [
  { title: "Buy 1 Get 1 Free", note: "Add minimum 2 products", tag: "SUMMER" },
  { title: "Buy 3 At ₹2999", note: "Add minimum 3 products", tag: "MEGA" },
  { title: "Buy 4 At ₹3599", note: "Add minimum 4 products", tag: "MEGA" },
];

const accordionData = [
  {
    title: "Product Details",
    content: "Crafted with precision, this Crystal Love Bangle features high-quality stainless steel with an 18K gold-plated finish. Embellished with sparkling crystal stones for a timeless look. Dimensions: 6cm inner diameter. Suitable for wrist sizes 14–17cm.",
  },
  {
    title: "Material & Care",
    content: "Material: Stainless Steel with 18K Gold Plating / Rose Gold Plating. Stones: Premium Austrian Crystal. Care: Avoid contact with water, perfume, and chemicals. Wipe clean with a soft cloth. Store in the provided jewellery pouch.",
  },
  {
    title: "Shipping & Returns",
    content: "Free shipping on orders above ₹999. Standard delivery: 5–7 business days. Express delivery available at checkout. Returns accepted within 7 days of delivery — item must be unworn and in original packaging.",
  },
];

export default function ProductDetail() {
  const { slug } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const item = location.state?.item;
  const { addItemToCart } = useCartContext();

  const [selectedColor, setSelectedColor] = useState("gold");
  const [selectedSize, setSelectedSize] = useState("M");
  const [giftWrap, setGiftWrap] = useState(false);
  const [qty, setQty] = useState(1);
  const [activeDeal, setActiveDeal] = useState(0);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [openAccordion, setOpenAccordion] = useState(null);
  const [wishlisted, setWishlisted] = useState(false);
  const [addedToCart, setAddedToCart] = useState(false);
  const [activeImage, setActiveImage] = useState(0);
  const [cartOpen, setCartOpen] = useState(false);
  const [cartQty, setCartQty] = useState(1);
  const [coupon, setCoupon] = useState("");
  const [showBreakdown, setShowBreakdown] = useState(false);

  const BASE_PRICE = 2659;
  const GIFT_WRAP_PRICE = 50;
  const itemTotal = BASE_PRICE * cartQty;
  const giftWrapTotal = giftWrap ? GIFT_WRAP_PRICE : 0;
  const discount = Math.round(itemTotal * 0.3);
  const estimatedTotal = itemTotal + giftWrapTotal;

  const prevImage = () =>
    setActiveImage((prev) => (prev - 1 + galleryImages.length) % galleryImages.length);
  const nextImage = () =>
    setActiveImage((prev) => (prev + 1) % galleryImages.length);

  // Add to cart (doesn't check login)
  const handleAddToCart = (item) => {
    if (!item) return;

    addItemToCart({
      product: item.id,
      name: item.name,
      price: parseFloat(item.price),
      old_price: item.old_price || "",
      image: item.image,
      stock: 10,
      seller: item.brand || "",
      contains_in_box: "",
      product_type: "simple",
      quantity: qty,
    });

    setAddedToCart(true);
    setCartOpen(true);
    setCartQty(qty);
  };

  // Buy it now with login check
  const handleBuyNow11 = () => {
    const customer = localStorage.getItem("customer");
    if (!customer) {
      setShowLoginModal(true);
      return;
    }
    handleAddToCart(item);
    navigate("/checkout");
  };

    const handleBuyNow = () => {
    const session = localStorage.getItem("session");

    if (session && session !== "undefined") {
      setCartOpen(false);
      navigate("/checkout");
    } else {
      setCartOpen(false);
      setShowLoginModal(true);
    }
  };


  return (
    <>
      <div className="product-page">
        <div className="product-grid">
          {/* LEFT: Gallery */}
          <div className="gallery-section">
            <div className="main-image-wrap">
              <span className="badge-bogo">Buy 1 Get 1</span>
              <button className="gallery-nav prev" onClick={prevImage}>‹</button>
              <img
                className="main-image"
                src={item?.image ? BASE_URL + item.image.replace(/\\/g, "/") : galleryImages[activeImage].src}
                alt={galleryImages[activeImage].alt}
              />
              <button className="gallery-nav next" onClick={nextImage}>›</button>
            </div>
            <div className="thumbnails">
              {galleryImages.map((img, i) => (
                <div
                  key={i}
                  className={`thumb ${activeImage === i ? "active" : ""}`}
                  onClick={() => setActiveImage(i)}
                >
                  <img src={img.thumb} alt={img.alt} />
                </div>
              ))}
            </div>
          </div>

          {/* RIGHT: Product Info */}
          <div className="product-info1">
            <div className="rating-row">
              <span className="stars">★★★★★</span>
              <span className="review-count">1,369 reviews</span>
            </div>
            <h1 className="product-title"><em>{item?.name}</em></h1>
            <div className="price-row">
              <span className="price-current">₹{item?.price}</span>
              <span className="price-mrp">₹{item?.old_price}</span>
              <span className="save-badge">Save 30%</span>
            </div>
            <div className="tax-note">Inclusive of all taxes</div>
            <div className="sku-row">SKU: BR076</div>

            {/* DEALS */}
            <div className="deals-section">
              <div className="deals-label">Deals</div>
              <div className="deal-cards">
                {deals.map((d, i) => (
                  <div
                    key={i}
                    className={`deal-card ${activeDeal === i ? "active" : ""}`}
                    onClick={() => setActiveDeal(i)}
                  >
                    <div className="deal-card-title">{d.title}</div>
                    <div className="deal-card-note">{d.note}</div>
                    <span className="deal-tag">{d.tag}</span>
                  </div>
                ))}
              </div>
            </div>

            <div className="stock-row"><span className="stock-dot" />In stock — ready to ship</div>

            {/* GIFT WRAP */}
            <div className="gift-wrap-row" onClick={() => setGiftWrap(!giftWrap)}>
              <div className={`gift-wrap-checkbox ${giftWrap ? "checked" : ""}`}>{giftWrap && "✓"}</div>
              <span className="gift-wrap-text">Add Special Gift Wrap <span>— ₹50</span></span>
            </div>

            {/* QTY */}
            <div className="qty-row">
              <span className="qty-label">Qty</span>
              <div className="qty-control">
                <button className="qty-btn" onClick={() => setQty(Math.max(1, qty - 1))}>−</button>
                <span className="qty-num">{qty}</span>
                <button className="qty-btn" onClick={() => setQty(qty + 1)}>+</button>
              </div>
            </div>

            <button className="btn-add-cart" onClick={() => handleAddToCart(item)}>
              <span>🛍</span>
              <span>{addedToCart ? "Added to Cart ✓" : "Add to Cart"}</span>
            </button>

            <button className="btn-buy-now" onClick={handleBuyNow}>Buy It Now</button>

            <button className="btn-wishlist" onClick={() => setWishlisted(!wishlisted)}>
              {wishlisted ? "❤" : "♡"} &nbsp;{wishlisted ? "Saved to Wishlist" : "Add to Wishlist"}
            </button>

            {/* PERKS */}
            <div className="perks-row">
              <div className="perk"><span className="perk-icon">🚚</span>Free Shipping</div>
              <div className="perk"><span className="perk-icon">↩</span>7-Day Returns</div>
              <div className="perk"><span className="perk-icon">🔒</span>Secure Payment</div>
            </div>

            {/* ACCORDION */}
            <div className="accordion">
              {accordionData.map((a, i) => (
                <div key={i} className="accordion-item">
                  <button className="accordion-header" onClick={() => setOpenAccordion(openAccordion === i ? null : i)}>
                    {a.title}
                    <span className={`accordion-icon ${openAccordion === i ? "open" : ""}`}>+</span>
                  </button>
                  {openAccordion === i && <div className="accordion-body">{a.content}</div>}
                </div>
              ))}
            </div>
          </div>
        </div>
       <LoginModal show={showLoginModal} onClose={() => setShowLoginModal(false)} logo={logo} />
      </div>
     <SpacialOffer />
     <SpacialOffer />
     {/* <RelatedProduct/> */}
    </>
  );
}